var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49948 5.3125C6.04854 5.3125 4.0625 7.29942 4.0625 9.75V18.75C4.0625 20.6485 5.60152 22.1875 7.5 22.1875H7.80321L7.80523 22.1876L7.8065 22.1878L7.80654 22.1878L7.80755 22.1884L7.80823 22.1889L7.80978 22.1902C7.8113 22.1917 7.81211 22.1935 7.8123 22.1939C7.81233 22.1941 7.8125 22.1949 7.8125 22.1968C7.8125 22.7107 7.83015 23.4737 8.02365 24.1247C8.12147 24.4538 8.28721 24.837 8.59098 25.1446C8.92337 25.4813 9.37177 25.6754 9.89362 25.6608C10.6966 25.6383 11.1694 25.1104 11.426 24.734C11.5562 24.5431 11.6665 24.3391 11.752 24.1804L11.7613 24.1631C11.8507 23.9973 11.9157 23.8766 11.9833 23.7722L12.2523 23.3569C12.7246 22.6277 13.5342 22.1875 14.4031 22.1875H21.5C23.9507 22.1875 25.9375 20.2011 25.9375 17.7503V9.74972C25.9375 7.29904 23.9514 5.3125 21.5005 5.3125H8.49948ZM10 15C10.6904 15 11.25 14.4404 11.25 13.75C11.25 13.0596 10.6904 12.5 10 12.5C9.30964 12.5 8.75 13.0596 8.75 13.75C8.75 14.4404 9.30964 15 10 15ZM16.25 13.75C16.25 14.4404 15.6904 15 15 15C14.3096 15 13.75 14.4404 13.75 13.75C13.75 13.0596 14.3096 12.5 15 12.5C15.6904 12.5 16.25 13.0596 16.25 13.75ZM20 15C20.6904 15 21.25 14.4404 21.25 13.75C21.25 13.0596 20.6904 12.5 20 12.5C19.3096 12.5 18.75 13.0596 18.75 13.75C18.75 14.4404 19.3096 15 20 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActive);
export default __webpack_public_path__ + "static/media/message-active.1ed698ef24928fae2f4570dc1b349cb9.svg";
export { ForwardRef as ReactComponent };